    angular.module('lead.activity', ['lead', 'document', 'sms'])
        .factory('LeadActivity', function ($resource) {
            return  $resource('/crm/api/lead-activity/:id', {id: "@id"}, {
                find: {method: 'GET', isArray: true},
                list: {method: 'GET', isArray: true},
                get: {method: 'GET'},
                table: {method: 'GET', isArray: false, url: '/crm/api/lead-activity/table'},
                tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/lead-activity/table-statistics'},
                last: {method: 'GET', isArray: false, url: '/crm/api/lead-activity/last'},
                update: {method: 'PUT'},
                sendSMS: {method: 'POST', url: '/crm/api/lead-activity/send-sms'},
                remove: {method: 'DELETE'}
            });
        })
        .service('LeadActivityService', function ($rootScope, toastr, modals, Lead, LeadActivity) {
            this.add = options => {
                let entity = {
                    id: null,
                    issueDate: new Date().toISOString()
                };
                angular.extend(entity, options);
                return modals.open('app/lead/activity/edit-modal.html', 'LeadActivityDialogController', entity, {size: "md"}, "$ctrl")
            }
            this.addForLeadId = leadId => {
                Lead.get({id: leadId}).$promise.then(lead => this.add({lead: lead}))
            }
            this.sendSMS = (leadId) => {
                return Lead.get({id: leadId}).$promise.then(lead => modals.open('app/lead/activity/sms-modal.html', 'LeadActivitySMSController', {lead: lead}, {size: 'md'}, "$ctrl"))
            }
            this.show = id => LeadActivity.get({id: id}).$promise.then(item => modals.open('app/lead/activity/show-modal.html', 'LeadActivityShowController', item, {size: "lg"}, "$ctrl"))
            this.import = () => modals.open('app/lead/activity/import.html', 'LeadActivityImportController', {}, {size: 'lg'})
            this.delete = item => modals.confirmDelete("wybraną aktywność", () => LeadActivity.delete({id: item.id}, () => $rootScope.$broadcast('lead.activity.updated')));
        })
        .controller('LeadActivitySMSController', function ($rootScope, $uibModalInstance, data, LeadActivity, toastr) {
            this.DEFAULT_PHONE_PREFIX = "+48"
            this.phonePatternWithoutPrefix = "^\\d{9}$"


            this.$onInit = () => {
                this.lead = data.lead
                this.item = {
                    leadId: data.lead.id,
                    phone: firstContactValue(data.lead.client, 'PHONE') || data.lead.sourcePhone
                }
                this.checkPhone()
            }

            function firstContactValue(client, type) {
                const contact = ((client && client.contacts) || []).find(item => item && item.type === type && item.value);
                return contact ? contact.value : null;
            }

            this.checkPhone = () => {
                if(this.item.phone == null)
                    return

                if(this.item.phone.match(this.phonePatternWithoutPrefix)){
                    this.item.phone = this.DEFAULT_PHONE_PREFIX + this.item.phone
                    this.defaultPrefixAdded = true
                }
            }


            this.send = () => {
                return LeadActivity.sendSMS(this.item).$promise.then(() => {
                    toastr.success("Wysłano")
                    $uibModalInstance.close()
                    $rootScope.$broadcast('lead.activity.updated')
                })
            }

            this.cancel = () => $uibModalInstance.dismiss('cancel')
        })
        .controller('LeadActivityImportController', function ($cookies, $scope, $rootScope, $http, $uibModalInstance, toastr, FileUploader) {
            $scope.types = ["CSV", "CSV-SIMPLE"];

            $scope.import = {
                type: "CSV-SIMPLE",
                charset: "CP1250",
                createRelatives: false
            };
            $scope.data = [];

            $scope.cancel = () => $uibModalInstance.dismiss('Canceled');

            $scope.uploader = createUploader();

            $scope.save = () => {
                if ($scope.isSaving)
                    return;
                $scope.isSaving = true;
                $http.post('/crm/api/lead-activity-batch/save-data', {items: $scope.data, createRelatives: $scope.import.createRelatives}).then(onSaveSuccess, onSaveError);
            };

            let onSaveSuccess = result => {
                toastr.success("Zapisano");
                $rootScope.$broadcast('lead.activity.updated');
                $uibModalInstance.close(result);
                $scope.isSaving = false;
            };

            let onSaveError = () => $scope.isSaving = false;

            function createUploader() {
                var uploader = new FileUploader({
                    url: '/crm/api/lead-activity-batch/read-data',
                    autoUpload: true,
                    headers: {
                        "X-Requested-With": 'XMLHttpRequest',
                        "X-CSRF-TOKEN": $cookies.get("CSRF-TOKEN")
                    }
                });
                uploader.onSuccessItem = function (fileItem, response, status, headers) {
                    toastr.success("Wczytano dane z pliku");
                    $scope.data = response;
                    angular.element("input[type='file']").val(null);
                };
                uploader.onErrorItem = function (fileItem, rejection, status, headers) {
                    if (angular.isArray(rejection.messages)) {
                        angular.forEach(rejection.messages, function (message, key) {
                            toastr.error(message);
                        });
                    }
                };
                uploader.onBeforeUploadItem = function (item) {
                    item.formData.push($scope.import);
                };
                return uploader;
            }
        })
        .controller('LeadActivityShowController', function ($scope, $uibModalInstance, data, LeadActivity) {
            this.item = data;

            this.close = () => $uibModalInstance.dismiss('Canceled');

            $scope.$on('lead.activity.updated', () => LeadActivity.get({id: data.id}, item => this.item = item));
        })
        .controller('LeadActivityDialogController', function ($rootScope, $uibModalInstance, data, LeadActivity) {
            this.statusWithoutNextContact = ["WAIT", "ERROR", "OUT", "CONTRACT"]

            this.item = data
            this.lead = angular.copy(data.lead)
            if(this.lead.state.status === "WAIT"){
                this.item.leadState = {
                    status: "START"
                }
            }
            if(this.lead.nextContact != null && moment().endOf('day').isBefore(this.lead.nextContact.date)){
                this.canLeaveCurrentNextContact = true
            }
            let statusToCheck = (this.item.leadState?.status) ? this.item.leadState.status : this.item.lead.state.status
            if(this.statusWithoutNextContact.includes(statusToCheck)){
                delete this.item.nextContact
            }
            else {
                this.item.nextContact = {}
            }

            this.cancel = () => $uibModalInstance.dismiss('Canceled')

            this.save = () => {
                if (this.isLeadManagerMissing()) {
                    return
                }
                if (this.isRequiredLeadDataMissing()) {
                    return
                }
                let promise
                if (this.item.id !== null) {
                    promise = LeadActivity.update(this.item).$promise
                } else {
                    promise = LeadActivity.save(this.item).$promise
                }
                return promise.then((result) => {
                    $rootScope.$broadcast('lead.activity.updated')
                    $uibModalInstance.close(result)
                })
            }

            this.changeStatus = () => {
                this.item.leadState = {
                    status: this.lead.status,
                    outStage: this.lead.outStage,
                    outReason: this.lead.outReason
                }
            }
            this.cancelChangeStatus = () => delete this.item.leadState

            this.onStatusChanged = () => {
                if(this.item.leadState.status !== "OUT"){
                    delete this.item.leadState.outStage
                    delete this.item.leadState.outReason
                }
                if(this.statusWithoutNextContact.includes(this.item.leadState.status)){
                    delete this.item.nextContact
                    return
                }
                if(!this.item.nextContact){
                    this.item.nextContact = {}
                }
            }
            this.changeProjects = () => {
                this.item.leadProjects = this.lead.projects
            }
            this.cancelChangeProjects = () => delete this.item.leadProjects
            this.setNextContactDate = (days) => {
                if(this.item.nextContact == null)
                    return
                this.item.nextContact.date = moment().add(days, 'days').format('YYYY-MM-DD')
            }
            this.setCurrentNextContact = () => {
                this.disableCurrentNextContact = true
                if(this.lead.nextContact == null)
                    return
                this.item.nextContact = angular.copy(this.lead.nextContact)
            }

            this.isLeadManagerMissing = () => !this.lead.managers || this.lead.managers.length === 0
            this.isRequiredLeadDataMissing = () => this.getMissingRequiredLeadDataLabels().length > 0

            this.getMissingRequiredLeadDataLabels = () => {
                if (['NOD', 'OUT'].includes(this.getTargetStatus())) {
                    return []
                }

                let lead = this.item.lead || {}
                let projects = this.item.leadProjects && this.item.leadProjects.length > 0 ? this.item.leadProjects : lead.projects
                let missing = []

                if (!lead.acquisitionSource) {
                    missing.push('źródło pozyskania leada')
                }
                if (!projects || projects.length === 0) {
                    missing.push('projekt')
                }
                if (!lead.tags || lead.tags.length === 0) {
                    missing.push('tagi')
                }
                return missing
            }

            this.getTargetStatus = () => this.item.leadState && this.item.leadState.status
                ? this.item.leadState.status
                : this.lead.state.status
        })
        .component('leadActivityList', {
            bindings: {
                filters: '<',
                page: '<',
                statistics: '<'
            },
            templateUrl: 'app/lead/activity/list.html',
            controller: function ($scope, $state, $stateParams, $httpParamSerializer, LeadActivityService, LeadService) {
                this.LeadActivityService = LeadActivityService
                this.LeadService = LeadService

                this.reset = () => this.filters = {};

                this.getExportUrl = (params) => {
                    let paramsAll = angular.copy($stateParams);
                    angular.extend(paramsAll, params);
                    return "/crm/api/lead-activity-batch/export?" + $httpParamSerializer(paramsAll)
                }

                $scope.$on('lead.activity.updated', () => $state.reload());
            }
        })
        .component('activitiesCount', {
            bindings: {
                count: '<'
            },
            template: '<span ng-if="$ctrl.count && $ctrl.count>0" class="document-info-header" title="Aktywności: {{$ctrl.count}}"><i class="fa fa-bookmark document-info-header"></i> {{$ctrl.count}}</span>'
        })
        .component('leadActivityBtnOptions', {
            bindings: {
                item: '<'
            },
            templateUrl: 'app/lead/activity/_btn-options.html',
            controller: function (LeadActivityService) {
                this.LeadActivityService = LeadActivityService
            }
        })
        .config(function ($stateProvider) {
            $stateProvider.state('leadActivityList', {
                parent: 'app',
                url: '/lead-activity?{page:int}&{size:int}&sort&search&periodStart&periodEnd&createdBy&manager&status&type&projects',
                data: {
                    authorities: ['ROLE_LEADS']
                },
                views: {
                    'content@': 'leadActivityList'
                },
                resolve: {
                    statistics: (LeadActivity, $stateParams) => LeadActivity.tableStatistics(angular.copy($stateParams)).$promise,
                    filters: $stateParams => angular.copy($stateParams),
                    page: (LeadActivity, $stateParams) => LeadActivity.table(angular.copy($stateParams)).$promise
                }
            });
        });
